// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-block{position:relative;width:100%;padding-bottom:50%;margin-top:20px;margin-bottom:20px}.video-block iframe,.video-block video{position:absolute;top:0;left:0;width:100%!important;height:100%!important}", ""]);
// Exports
module.exports = exports;
